var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
__name(_extends, "_extends");
import React from "react";
import { Row, Col } from "@riseart/antd-provider";
import { BasePlaceholder } from "@riseart/common";
import { artistListArtsCls, artistListArtsColCls } from "./Arts.less";
var ArtistListArtsPlaceholder = /* @__PURE__ */ __name(function ArtistListArtsPlaceholder2(_ref) {
  var _ref$itemsCount = _ref.itemsCount, itemsCount = _ref$itemsCount === void 0 ? 5 : _ref$itemsCount;
  return /* @__PURE__ */ React.createElement(Row, {
    type: "flex",
    gutter: 12,
    className: artistListArtsCls
  }, Array.apply(0, Array(itemsCount)).map(function(item, idx) {
    return /* @__PURE__ */ React.createElement(Col, _extends({
      key: idx
    }, itemsCount === 3 && idx > 2 ? {
      span: 0
    } : {}, {
      className: artistListArtsColCls
    }), /* @__PURE__ */ React.createElement(BasePlaceholder, null));
  }));
}, "ArtistListArtsPlaceholder");
export {
  ArtistListArtsPlaceholder
};
